function injectStyle (ssrContext) {
  require("!!../../../../../../../opt/devenv/allscs-jhh/repair-ui/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../../../opt/devenv/allscs-jhh/repair-ui/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-ec674ee0\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../../../../../opt/devenv/allscs-jhh/repair-ui/node_modules/vue-loader/lib/selector?type=styles&index=0!./dispatchLook.vue")
}
var Component = require("!../../../../../../../opt/devenv/allscs-jhh/repair-ui/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../opt/devenv/allscs-jhh/repair-ui/node_modules/vue-loader/lib/selector?type=script&index=0!./dispatchLook.vue"),
  /* template */
  require("!!../../../../../../../opt/devenv/allscs-jhh/repair-ui/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-ec674ee0\",\"hasScoped\":true,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../../../../../opt/devenv/allscs-jhh/repair-ui/node_modules/vue-loader/lib/selector?type=template&index=0!./dispatchLook.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ec674ee0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/dispatchOrder/dispatchLook.vue
// module id = 1457
// module chunks = 0